import actions from "./actions";

const initialState = {
  saving: false,
  detail: null,
  current: null,
  loadingCurrent: false,
  histories: [],
  loadingHistories: false,
  loadingList: false,
  items: [],
  total: 0,
  error: null,
};

export default function rakutenScoringSettingReducer(state = initialState, action) {
  switch (action.type) {
    case actions.CREATE_REQUEST:
      return { ...state, saving: true, error: null };
    case actions.CREATE_SUCCESS:
      return { ...state, saving: false };
    case actions.CREATE_ERROR:
      return { ...state, saving: false, error: action.error || null };
    case actions.GET_DETAIL_SUCCESS:
      return { ...state, detail: action.detail || null };
    case actions.UPDATE_REQUEST:
      return { ...state, saving: true, error: null };
    case actions.UPDATE_SUCCESS:
      return { ...state, saving: false };
    case actions.UPDATE_ERROR:
      return { ...state, saving: false, error: action.error || null };
    case actions.CURRENT_REQUEST:
      return { ...state, loadingCurrent: true };
    case actions.CURRENT_SUCCESS:
      return { ...state, loadingCurrent: false, current: action.current || null };
    case actions.CURRENT_ERROR:
      return { ...state, loadingCurrent: false };
    case actions.HISTORIES_REQUEST:
      return { ...state, loadingHistories: true };
    case actions.HISTORIES_SUCCESS:
      return { ...state, loadingHistories: false, histories: action.histories || [] };
    case actions.HISTORIES_ERROR:
      return { ...state, loadingHistories: false };
    case actions.SEARCH_REQUEST:
      return { ...state, loadingList: true, error: null };
    case actions.SEARCH_SUCCESS:
      return {
        ...state,
        loadingList: false,
        items: action.items || [],
        total: Number.isFinite(Number(action.total)) ? Number(action.total) : 0,
      };
    case actions.SEARCH_ERROR:
      return { ...state, loadingList: false, items: [], total: 0, error: action.error };
    default:
      return state;
  }
}
